var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
const QUESTION_SELECTOR = "[data-question-id]";
const MANDATORY_LABEL_SELECTOR = "[data-mandatory='true']";
const STEP_SELECTOR = ".response-questionnaire__step";
const CHECKED_SELECTOR = "input[type=radio]:checked, input[type=checkbox]:checked";
const LIST_SELECTOR = "[data-mandatory-questions-list]";
const TOS_SELECTOR = ".response-questionnaire__tos input[type=checkbox]";
export default class mandatory_questions_controller_default extends Controller {
  connect() {
    this.form = this.element.querySelector("form.response-questionnaire");
    if (!this.form) return;
    this.onClickCapture = this.onClickCapture.bind(this);
    this.onSubmitCapture = this.onSubmitCapture.bind(this);
    document.addEventListener("click", this.onClickCapture, true);
    this.form.addEventListener("submit", this.onSubmitCapture, true);
  }
  disconnect() {
    document.removeEventListener("click", this.onClickCapture, true);
    if (this.form) this.form.removeEventListener("submit", this.onSubmitCapture, true);
  }
  onClickCapture(event) {
    const control = event.target.closest("button, input[type=submit]");
    if (!control || !this.form.contains(control) || !this.advances(control)) return;
    this.guard(event, control.closest(STEP_SELECTOR));
  }
  // The keyboard path: pressing Enter in a text field submits without any
  // click, so the button listener above never sees it.
  onSubmitCapture(event) {
    const steps = Array.from(this.form.querySelectorAll(STEP_SELECTOR)).filter((step) => this.visible(step));
    this.guard(event, steps[steps.length - 1]);
  }
  // Blocking without being able to say why would be worse than letting the
  // server answer, so an unavailable dialog means the event goes through.
  guard(event, step) {
    const missing = [...this.missingQuestions(step), ...this.missingTos(step)];
    if (missing.length === 0) return;
    const dialog = this.dialog();
    if (!dialog) return;
    event.preventDefault();
    event.stopPropagation();
    this.fillList(missing);
    dialog.open();
  }
  // Both navigation buttons are the same core `toggle` controller, and only the
  // step they point at tells them apart: `"step-3 step-2"` moves forward,
  // `"step-1 step-2"` goes back. The submit input always counts.
  advances(control) {
    if (control.type === "submit") return true;
    const value = control.dataset.toggleToggleValue;
    if (!value) return false;
    const [target, current] = value.split(" ").map((id) => parseInt(id.replace("step-", ""), 10));
    return Number.isInteger(target) && Number.isInteger(current) && target > current;
  }
  missingQuestions(step) {
    if (!step) return [];
    return Array.from(step.querySelectorAll(QUESTION_SELECTOR)).filter((question) => this.visible(question)).map((question) => ({ question, label: question.querySelector(MANDATORY_LABEL_SELECTOR) })).filter(({ question, label }) => label && !this.answered(question, label.dataset.questionType)).map(({ label }) => label.textContent.replace(/\s+/gu, " ").trim());
  }
  // O aceite dos termos não é uma pergunta — vem do `QuestionnaireForm`, que o
  // valida com `acceptance: true` — mas para quem responde é mais um campo
  // obrigatório da última seção, e ficava de fora do aviso.
  missingTos(step) {
    if (!step) return [];
    const checkbox = step.querySelector(TOS_SELECTOR);
    if (!checkbox || checkbox.checked || !this.visible(checkbox)) return [];
    return [this.tosLabelValue];
  }
  // Mirrors `Decidim::Forms::ResponseForm` question by question, so nothing is
  // rejected here that the server would have accepted.
  answered(question, type) {
    switch (type) {
      case "short_response":
      case "long_response":
        return this.filledIn(question);
      case "single_option":
      case "multiple_option":
        return question.querySelector(CHECKED_SELECTOR) !== null;
      // `min_choices` demands one choice per row, not just one in the table.
      case "matrix_single":
      case "matrix_multiple":
        return this.everyRowChecked(question);
      // Direct upload puts the blob on the server as soon as the progress bar
      // completes, and core rewrites this list when the upload modal is saved.
      case "files":
        return question.querySelector("[data-active-uploads] [data-filename]") !== null;
      // `sorting` has no unanswered state: every option is submitted with its
      // body already filled in and the order is taken from the DOM, so
      // `all_choices` passes whether or not the participant dragged anything.
      default:
        return true;
    }
  }
  filledIn(question) {
    const field = question.querySelector("textarea, input[type=text]");
    return Boolean(field && field.value.trim());
  }
  everyRowChecked(question) {
    const rows = Array.from(question.querySelectorAll("tbody tr"));
    return rows.length > 0 && rows.every((row) => row.querySelector(CHECKED_SELECTOR) !== null);
  }
  visible(element) {
    return element.offsetParent !== null;
  }
  // The dialog cannot be a Stimulus target: core moves every `[data-dialog]`
  // to `<body>` when it initialises them, so by the time this runs the modal is
  // no longer inside this controller's element.
  dialog() {
    return window.Decidim && window.Decidim.currentDialogs && window.Decidim.currentDialogs[this.dialogIdValue];
  }
  fillList(labels) {
    const list = document.querySelector(`#${this.dialogIdValue} ${LIST_SELECTOR}`);
    if (!list) return;
    list.replaceChildren(...labels.map((text) => {
      const item = document.createElement("li");
      item.textContent = text;
      return item;
    }));
  }
}
__publicField(mandatory_questions_controller_default, "values", {
  dialogId: String,
  tosLabel: String
});
